import '../vendor/hammer.min.js';

export default () => ({
  slide: 0,
  slides: 0,
  init() {
    let len = this.$refs.body.children.length;

    if (window.matchMedia('(max-width: 639px)').matches) {
      this.slides = len;
    } else {
      this.slides = len - ((len % 2 == 0) ? 1 : 2);
    }    
    
    let hammertime = new Hammer(this.$el);
    hammertime.on('swipeleft', () => this.slideLeft());
    hammertime.on('swiperight', () => this.slideRight());

    console.log(this.$refs.body.children[this.slide].offsetLeft);

    this.$watch('slide', val => {
      let child = this.$refs.body.children[this.slide];

      this.$refs.body.style.transform = `translateX(calc(-${child.offsetLeft}px))`;
    });
  },
  slideRight() {
    if (this.slide != 0) {
      -- this.slide;
    }
  },
  slideLeft() {
    if (this.slide != this.slides - 1) {
      ++ this.slide;
    }
  }
})